module.exports = __webpack_public_path__ + "media/images/lb/262-c41182ed01b979a44640a53f76acbca5.svg";